import { useState, useEffect } from "react";
import { socialMediaFetcher } from "../../api/requests";
import { baseURL } from "../../api/dataFetcher";
import { useLocation } from "react-router-dom";

export default function SingleChannelHero({ channel, id }) {
  const [socials, setSocials] = useState();
  const [error, setError] = useState(null);
  const location = useLocation();
  const campaignId = new URLSearchParams(location.search).get("campaign");

  useEffect(() => {
    const getSocialMedia = async () => {
      try {
        const data = await socialMediaFetcher.get(id);
        setSocials(data);
      } catch (err) {
        console.error("Error fetching social media data:", err);
        setError("خطا در ارتباط با شبکه  ");
      }
    };

    !campaignId && getSocialMedia();
  }, [id]);

  return (
    <>
      <div className="single-channel-image">
        <img
          style={{ objectFit: "cover", maxHeight: "366px" }}
          className="img-fluid"
          alt="بنر کانال"
          src={
            channel?.banner
              ? baseURL + channel.banner
              : "/img/channel-banner.png"
          }
        />
        <div className="channel-profile">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "15px",
            }}
          >
            <img
              style={{ objectFit: "cover" }}
              className="channel-profile-img"
              alt="تصویر پروفایل"
              src={
                campaignId
                  ? channel?.banner
                    ? baseURL + channel.banner
                    : "/img/s2.png"
                  : channel?.avatar
                  ? baseURL + channel.avatar
                  : "/img/s2.png"
              }
            />
            <div style={{ display: "flex", gap: "5px" }}>
              {channel?.counted_view ? (
                <div
                  style={{
                    backgroundColor: "#F0F0F0B5",
                    color: "#1E1E1E",
                    padding: "2px 5px",
                    borderRadius: "5px",
                    display: "flex",
                    alignItems: "center",
                    gap: "3px",
                  }}
                >
                  <span>بازدید کانال:</span>
                  <span>
                    {channel?.counted_view ? channel?.counted_view : ""}
                  </span>
                </div>
              ) : (
                ""
              )}
              {channel?.total_video_views ? (
                <div
                  style={{
                    backgroundColor: "#F0F0F0B5",
                    color: "#1E1E1E",
                    padding: "2px 5px",
                    borderRadius: "5px",
                    display: "flex",
                    alignItems: "center",
                    gap: "3px",
                  }}
                >
                  <span>بازدید ویدئوها:</span>
                  <span>
                    {channel?.total_video_views
                      ? channel?.total_video_views
                      : ""}
                  </span>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          {campaignId ? (
            <div
              className="social hidden-xs"
              style={{
                backgroundColor: "#F0F0F091",
                padding: "8px 18px",
                borderRadius: "5px",
                fontSize: "16px",
                color: "#1E1E1E",
                whiteSpace: "pre-line",
                height: "fit-content",
              }}
            >
              {channel?.Terms_participation_in_campaign}
            </div>
          ) : (
            <div className="social hidden-xs">
              {error ? (
                <span>{error}</span>
              ) : (
                socials?.results.map((item, index) => (
                  <a
                    key={index}
                    className="mr-1"
                    href={item.link}
                    style={{ width: "fit-content", display: "inline-block" }}
                  >
                    {item.name}
                  </a>
                ))
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
